export default __webpack_public_path__ + "static/media/check.3991c572.svg";